module.exports = __webpack_public_path__ + "static/media/owner-connect-logo.dcb9dcaa.svg";